import { HiDocumentReport, HiShoppingCart } from "react-icons/hi";
import { IoIosFitness, IoIosPeople } from "react-icons/io";
import { MdAdminPanelSettings, MdCoffee } from "react-icons/md";
import { BiCategoryAlt } from "react-icons/bi";

import Colors from "../../constant/Colors";
import { GiPillDrop, GiPlayerNext, GiTakeMyMoney } from "react-icons/gi";
import { FiSend } from "react-icons/fi";
import { FaRegCreditCard, FaRegUser } from "react-icons/fa";
import { CgPill } from "react-icons/cg";

// eslint-disable-next-line import/no-anonymous-default-export
export default [
  {
    display: "users",
    icon: <IoIosPeople size={28} color={Colors.mainWhite} />,
    to: `/users`,
    section: "users",
    type: [0, 1, 2],
  },
  {
    display: "dailyReport",
    icon: <HiDocumentReport size={24} color={Colors.mainWhite} />,
    to: `/dailyReport`,
    section: "dailyReport",
    type: [0, 2, 4],
  },
  {
    display: "cafeteria",
    icon: <MdCoffee size={24} color={Colors.mainWhite} />,
    to: `/cafeteria`,
    section: "cafeteria",
    type: [0, 4],
  },
  {
    display: "requestCourse",
    icon: <IoIosFitness className="h-full" color={Colors.mainWhite} size={28} />,
    to: `/courses`,
    section: "courses",
    type: [0, 1],
  },
  {
    display: "expenses",
    icon: <GiTakeMyMoney
      color={Colors.mainWhite}
      size={26}
    />,
    to: `/expenses`,
    section: "expenses",
    type: [0,2],
  },
  {
    display: "cafeteria-card",
    icon: <FaRegCreditCard
      color={Colors.mainWhite}
      size={23}
    />,
    to: `/cafeteria-card?type=1`,
    section: "cafeteria-card",
    type: [0, 2],
  },
  {
    display: "others",
    icon: <BiCategoryAlt size={24} color={Colors.mainWhite} />,
    to: `/others`,
    section: "others",
    type: [0, 4],
  },
  
];
